import React from "react";
import { Play, Target, Pause, Heart, ArrowRight } from "lucide-react";

const MicrocycleTimeline = ({ scenario, isDarkMode }) => {
  if (!scenario) return null;

  const typeConfig = {
    training: { icon: Play, label: "Training", color: "emerald" },
    match: { icon: Target, label: "Match", color: "rose" },
    rest: { icon: Pause, label: "Rest", color: "gray" },
    recovery: { icon: Heart, label: "Recovery", color: "cyan" },
  };

  return (
    <div className="flex items-center justify-center gap-1 py-3">
      {scenario.days.map((day, idx) => {
        const config = typeConfig[day.type] || typeConfig.rest;
        const Icon = config.icon;
        const colorClasses = {
          emerald: isDarkMode ? "text-emerald-400" : "text-emerald-600",
          rose: isDarkMode ? "text-rose-400" : "text-rose-600",
          gray: isDarkMode ? "text-gray-500" : "text-gray-400",
          cyan: isDarkMode ? "text-cyan-400" : "text-cyan-600",
        };
        
        return (
          <React.Fragment key={idx}>
            {/* Day module */}
            <div className="flex flex-col items-center">
              <div className={`p-2 rounded-lg ${isDarkMode ? "bg-gray-800/50" : "bg-gray-50"}`}>
                <Icon size={18} className={colorClasses[config.color]} />
              </div>
              <span className={`text-[10px] mt-1 font-medium ${colorClasses[config.color]}`}>
                {day.label}
              </span>
            </div>
            
            {/* Arrow between days */}
            {idx < scenario.days.length - 1 && (
              <ArrowRight size={14} className={isDarkMode ? "text-gray-600" : "text-gray-300"} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MicrocycleTimeline;
